import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": "title",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"none\" stroke=\"#7C3AED\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"5.5\" d=\"M25 10h-6a9 9 0 0 0-9 9v6m29-15h6a9 9 0 0 1 9 9v6m0 14v6a9 9 0 0 1-9 9h-6m-14 0h-6a9 9 0 0 1-9-9v-6\"></path><g fill=\"none\" stroke=\"#7C3AED\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3.2\"><rect width=\"18\" height=\"10\" x=\"18\" y=\"19\" rx=\"4\"></rect><path d=\"m24 29-3 3v-3\"></path><rect width=\"18\" height=\"10\" x=\"29\" y=\"35\" rx=\"4\"></rect><path d=\"m41 45 3 3v-3\"></path></g>", 2)
  ]))]))
}
export default { render: render }